import * as React from "react";
import { BooleanField, BooleanInput, TabbedForm, FormTab, FunctionField, Tab, TabbedShowLayout, EditButton, TopToolbar, DateField, Show, SimpleShowLayout, RichTextField, DateInput, Edit, List, Datagrid, TextField, EmailField, SimpleForm, TextInput, ReferenceInput, Create } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices
} from 'react-admin';

export const WorkorderStatusList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Display" />
            <TextField source="description" />
            <TextField source="code" label="Code"/>
            <TextField source="seq" label="Sequence"/>
            <BooleanField source="notifyCustomer" label="Notify Customer?"/>
        </Datagrid>
    </List>
);



export const WorkorderStatusCreate = props => (
    <Create title="Create a new Work Order" {...props}>
        <SimpleForm>

            <TextInput source="name" label="Display" validate={required()}/>
            <TextInput source="description" />
            <TextInput source="code" label="Code"/>
            <TextInput source="seq" label="Sequence"/>
            <BooleanInput source="notifyCustomer" label="Notify Customer?"/>
            <TextInput source="changeRule" label="Can be changed from"/>

        </SimpleForm>
    </Create>
);


export const WorkorderStatusEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
                        <TextInput source="name" label="Display" validate={required()}/>
                        <TextInput source="description" />
                        <TextInput source="code" label="Code"/>
                        <TextInput source="seq" label="Sequence"/>
                        <BooleanInput source="notifyCustomer" label="Notify Customer?"/>
                        <TextInput source="changeRule" label="Can be changed from"/>
        </SimpleForm>
    </Edit>
);
